import React from "react";
import Seo from "../components/Generic/Seo";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";

const MentorShip = () => {
  const seoData = {
    title: "Mentorship - Wise Community",
    description:
      "Join Wise Community's mentorship program to connect with experienced professionals in the semiconductor ecosystem.",
    keywords:
      "Mentorship, Wise Community, semiconductor, women in tech, professional development",
    pathSlug: "mentorship",
  };

  return (
    <>
      <Seo data={seoData} />

       <GoogleAnalytics
        page={seoData.pathSlug}
        title={ seoData.title}
      />

      <div className="p-5">
        <h1>Mentorship</h1>
        <p>This is the mentorship page content</p>
      </div>
    </>
  );
};

export default MentorShip;
